module.exports = __webpack_public_path__ + "static/media/login_text_bg.7626f7a4.png";